import React from "react";
import styles from "./CustomerServices.module.css";
import CustomerServicesCard from "../../Components/CustomerServices/CustomerServicesCard";
import * as FaIcons from "react-icons/fa";
import { GiBowTieRibbon } from "react-icons/gi";
import * as Bootstrap from "react-icons/bs";
import * as Gr from "react-icons/gr";
import * as Lu from "react-icons/lu";
import PersonalisationIcon from "../../Components/CustomerServices/PersonalisationIcon";
import Ribbon from "../../Components/CustomerServices/Ribbon";
import Header from "../../Components/Shared/Header/Header";
import SharedHeader from "../../Components/Shared/SharedHeader";
import commonStyles from "../../Components/Shared/commonStyles.module.css";

function CustomerServices() {
  const sections = [
    {
      Name: "Personalisation",
      Text: "Customise your gifts with names, messages, or designs.",
      Icon: <FaIcons.FaUserCog className={styles.Ribbon} />,
      Link: "Personalisation",
    },
    {
      Name: "Gift Wrap",
      Text: "Beautifully wrapped, finished with a personalised gift tag.",
      Icon: <GiBowTieRibbon className={styles.Ribbon} />,
      Link: "Giftwrap",
    },
    {
      Name: "Frequently Asked Questions",
      Text: "Quick answers about ordering, personalisation, and delivery.",
      Icon: <FaIcons.FaQuestion className={styles.Question} />,
      Link: "FAQ",
    },
    {
      Name: "Contact Us",
      Text: "Email or WhatsApp your enquiry - we’re here to help.",
      Icon: <FaIcons.FaPhoneAlt className={styles.ContactUs} />,
      Link: "Contact",
    },
    {
      Name: "Customer Reviews",
      Text: "Hear from our happy customers and their loved ones.",
      Icon: <Bootstrap.BsChatText className={styles.Reviews} />,
      Link: "Reviews",
    },
    {
      Name: "Our Story",
      Text: "Discover our history, mission, partners, and the team.",
      Icon: <FaIcons.FaBookOpen className={styles.Book} />,
      Link: "OurStory",
    },
    {
      Name: "Terms and Policies",
      Text: "Extra information regarding our processes and delivery.",
      Icon: <Gr.GrDocumentText className={styles.Terms} />,
      Link: "Terms",
    },   
    {
      Name: "Pop-Up Dates",
      Text: "Meet us in person and shop our collection at upcoming events. ",
      Link: "Popups",
      Icon: <FaIcons.FaSearchLocation   className={styles.Location} />,
    }
  ];

  return (
    <div className={commonStyles.section}>
      <div className={commonStyles.container}>
        <div className={styles.sectionHeaderContainer}>
          <h2 className={commonStyles.sectionHeader}>CUSTOMER SERVICES</h2>
          <p>
            We’re here to make gifting simple, personal, and stress-free.
            Explore our guides and support options below.
          </p>
        </div>
        <div className={commonStyles.cards4}>
          {sections.map((s, i) => (
            <CustomerServicesCard
              key={i}
              Name={s.Name}
              Text={s.Text}
              Icon={s.Icon}
              Link={s.Link}
            />
          ))}
        </div>
      </div>
    </div>
  );
}

export default CustomerServices;
